__webpack_require__.p = "/corgi/pageapps/prepurchase/_next/";